function withPermission (code, node) {
  return hasPermission(code) ? node : null
}

function hasPermission (code) {
  const localUserInfo = window.userInfo || JSON.parse(localStorage.getItem('userInfo') || '{}')
  let permCodes = []
  if (localUserInfo && localUserInfo.resource && localUserInfo.resource.permCodes) {
    permCodes = localUserInfo.resource.permCodes || []
  }
  return permCodes.includes(code)
}

function hasFinaljudgmentEditPermission () {
  return hasPermission('rp:finaljudgment:editable')
}

export {
  withPermission,
  hasPermission,
  hasFinaljudgmentEditPermission
}
